import React from 'react';
import { ChevronLeft, MoreVertical } from 'lucide-react';
import { PhoneIcon, VideoCameraIcon } from '@heroicons/react/24/solid';
import { getTimeAgo } from '../../../utils/timeUtils';

export default function ChatHeader({ chatId, chatInfo, peerPresence, fromSettings, onBack, onOpenSettings, onStartAudioCall, onStartVideoCall }) {
  return (
    <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-neutral-800 mt-8">
      <div className="flex items-center gap-4">
        <button onClick={onBack}>
          <ChevronLeft className="w-8 h-8 text-black dark:text-white" />
        </button>
        {chatInfo?.profile_url ? (
          <img src={chatInfo.profile_url} alt="Profile" className="w-10 h-10 rounded-full object-cover" />
        ) : chatInfo?.is_group ? (
          <img src="/assets/images/default_group_picture.png" alt="Profile" className="w-10 h-10 rounded-full object-cover" />
        ) : (
          <img src="/assets/images/default_profile.png" alt="Profile" className="w-10 h-10 rounded-full object-cover" />
        )}
        <div className="flex flex-col">
          <h1 className="text-lg font-bold">{chatInfo?.chat_name || ''}</h1>

          {!chatInfo?.is_group && (() => {
            const isOnline = peerPresence.status === 'online';
            const last = peerPresence.last_active ? new Date(peerPresence.last_active).getTime() : null;
            const withinDay = last && (Date.now() - last) < 24 * 60 * 60 * 1000;

            if (isOnline) {
              return (
                <div className="flex items-center gap-1">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span className="text-xs text-gray-500 dark:text-gray-300">Active now</span>
                </div>
              );
            }
            if (!isOnline && withinDay) {
              return (
                <div className="flex items-center gap-1">
                  <span className="text-xs text-gray-500 dark:text-gray-300">
                    Active {getTimeAgo(peerPresence.last_active) == 'now' ? 'seconds ago' : getTimeAgo(peerPresence.last_active)}
                  </span>
                </div>
              );
            }
            return null;
          })()}
        </div>
      </div>
      <div className="flex items-center gap-4">
        {!chatInfo?.is_group && (
          <>
            <PhoneIcon className="w-6 h-6 text-black dark:text-white cursor-pointer" onClick={onStartAudioCall} />
            <VideoCameraIcon className="w-6 h-6 text-black dark:text-white cursor-pointer" onClick={onStartVideoCall} />
          </>
        )}
        <MoreVertical className="w-6 h-6 text-black dark:text-white cursor-pointer" onClick={() => onOpenSettings(chatId, chatInfo)} />
      </div>
    </div>
  );
}
